export default "__VITE_ASSET__BnntmWnW__"